import routeCodes from 'common/constants/route-codes';

import * as types from './types';
import { optionSteps } from 'common/constants/menu';

const initialState = {
  listData: {
    id: 'dish-options',
    title: 'Le opzioni',
    description:
      'Crea e modifica le opzioni di personalizzazione dei tuoi piatti/prodotti.',
    href: routeCodes.menuOptionsEdit,
    createLink: routeCodes.menuOptionsCreate,
    items: [],
  },
  itemLoading: false,
  currentItem: {},
  deleteInProcess: false,
  errors: null,
  listFetched: false,
  createOrUpdateInProcess: false,
  formStep: optionSteps.first,
  completedSteps: [optionSteps.first],
};

const dishOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DISH_OPTIONS_CATEGORY_GET_SUCCESS:
      return {
        ...state,
        listFetched: true,
        listData: {
          ...state.listData,
          items: action.payload,
        },
      };
    case types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_REQUEST:
      return {
        ...state,
        createOrUpdateInProcess: true,
      };
    case types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_FAILURE:
      return {
        ...state,
        createOrUpdateInProcess: false,
        errors: action.payload,
      };
    case types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_SUCCESS:
      return {
        ...state,
        createOrUpdateInProcess: false,
      };
    case types.RESET_DISH_OPTIONS_LIST_DATA:
      return {
        ...state,
        listFetched: false,
        listData: {
          id: 'dish-options',
          title: 'Le opzioni',
          description:
            'Crea e modifica le opzioni di personalizzazione dei tuoi piatti/prodotti.',
          href: routeCodes.menuOptionsEdit,
          createLink: routeCodes.menuOptionsCreate,
          items: [],
        },
      };
    case types.CHANGE_DISH_OPTIONS_FORM_STEP:
      return {
        ...state,
        formStep: action.payload.step,
        completedSteps: action.payload.completedSteps,
      };
    default:
      return state;
  }
};

export default dishOptionsReducer;
